import { render, staticRenderFns } from "./MemorialHallSet.vue?vue&type=template&id=9bea2912&scoped=true"
import script from "./MemorialHallSet.vue?vue&type=script&lang=js"
export * from "./MemorialHallSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bea2912",
  null
  
)

export default component.exports